import { ApplicationConfig, provideZoneChangeDetection } from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter, withComponentInputBinding } from "@angular/router";
import { provideRouterStore, routerReducer } from "@ngrx/router-store";
import { provideStore } from "@ngrx/store";
import { provideStoreDevtools } from "@ngrx/store-devtools";
import { provideTopVisApp } from "@vega/bootstrap";
import { provideBridgeActions } from "@vega/bridge";
import { provideGrid } from "@vega/igx-grid";
import { provideScanner } from "@vega/scanner";
import { provideSettings } from "@vega/settings";
import { provideActionBar, TOOLBAR_ACTIONS } from "@vega/ui-toolbox/action-bar";
import { appConfiguration, appSettings } from "src/environments/app-settings";
import { routes } from "./app.routes";
import { metaReducers } from "./store/app.reducer";
import { ToolBarBridgeActions } from "./bootstrap/toolbar-bridge-actions";
import { CanCloseAction } from "./use-cases/shared/angular-provided-actions/can-close-action";
import { provideNgxStripe } from "ngx-stripe";

const reducers = {
    router: routerReducer
};

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),

        provideAnimations(),

        // App
        provideTopVisApp(appConfiguration),
        provideBridgeActions([CanCloseAction]),
        provideActionBar({
            toolBarActionsProvider: {
                provide: TOOLBAR_ACTIONS,
                useClass: ToolBarBridgeActions
            }
        }),
        provideGrid(),
        provideSettings(),
        provideScanner(),
        provideRouter(routes, withComponentInputBinding()),
        provideStore(reducers, {
            metaReducers,
            runtimeChecks: {
                strictStateSerializability: true
            }
        }),
        provideRouterStore(),
        provideNgxStripe(),

        provideStoreDevtools({
            maxAge: 25, // Retains last 25 states
            logOnly: appSettings.production, // Restrict extension to log-only mode
            autoPause: true, // Pauses recording actions and state changes when the extension window is not open
            trace: false, //  If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
            traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided as true)
            connectInZone: true // If set to true, the connection is established within the Angular zone
        })
    ]
};
